import { createBrowserHistory } from 'history'
import queryString from 'query-string'

// add routerHistory middleware and reducer

const browserHistory = createBrowserHistory()

browserHistory.refresh = () => {
  window.location.reload()
}

browserHistory.pushPath = (path) => {
  browserHistory.push({
    ...browserHistory.location,
    pathname: path,
  })
}

browserHistory.extend = (path) => {
  browserHistory.push({
    pathname: `${browserHistory.location.pathname}${path}`,
  })
}

browserHistory.parseQuery = () => {
  return queryString.parse(browserHistory.location.search)
}

browserHistory.setState = (state) => {
  browserHistory.push({
    ...browserHistory.location,
    state,
  })
}

export const history = browserHistory
export default history
